
import React from "react";
import { Link } from "react-router-dom";
import { CardTitle } from "@/components/ui/card";
import { Lock } from "lucide-react";

type Entry = {
  id: string;
  title: string;
  password?: string | null;
};

type EntryCardHeaderProps = {
  entry: Entry;
};

export const EntryCardHeader: React.FC<EntryCardHeaderProps> = ({ entry }) => {
  return (
    <Link to={`/dashboard/entry/${entry.id}`}>
      <CardTitle className="text-lg hover:text-blue-600 hover:underline transition-colors line-clamp-1">
        {entry.password && <Lock className="inline h-4 w-4 mr-1" />}
        {entry.title}
      </CardTitle>
    </Link>
  );
};
